import { render, staticRenderFns } from "./BsAppContainer.vue?vue&type=template&id=4b46686d&"
import script from "./BsAppContainer.vue?vue&type=script&lang=js&"
export * from "./BsAppContainer.vue?vue&type=script&lang=js&"
import style0 from "./BsAppContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports